export enum WorkspaceStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}
